import UserDashboardContainer from "../../../components/pages/other/userDashboard";

const UserDashboard = () => {
  return <UserDashboardContainer />;
};

export default UserDashboard;
